import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { FOUNDER, pageHead, SITE_URL } from "@/lib/seo";

const TITLE = "Fractional CMO | Directeur marketing à temps partagé – CMO Partner";
const DESCRIPTION =
  "Fractional CMO et directeur marketing à temps partagé pour PME et ETI : stratégie, CRM, IA. 2 à 12 jours par mois, sur devis. Basé à Bordeaux.";

const areaServed = [
  { "@type": "City", name: "Bordeaux" },
  { "@type": "AdministrativeArea", name: "Gironde" },
  { "@type": "AdministrativeArea", name: "Nouvelle-Aquitaine" },
  { "@type": "Country", name: "France" },
];

export const Route = createFileRoute("/")({
  head: () =>
    pageHead({
      path: "/",
      title: TITLE,
      description: DESCRIPTION,
      enPath: null,
      schemas: [
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "CMO Partner",
          url: SITE_URL,
          description: "Fractional CMO, directeur marketing à temps partagé et externalisé pour PME et ETI.",
          alternateName: ["Fractional CMO", "Directeur marketing à temps partagé", "Directeur marketing externalisé"],
          knowsAbout: ["Directeur marketing à temps partagé", "Directeur marketing externalisé", "Fractional CMO"],
          founder: FOUNDER,
          sameAs: ["https://linkedin.com/in/tiphanyrigaudias"],
        },
        {
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          name: "CMO Partner",
          alternateName: ["Directrice marketing externalisée", "Directeur marketing externalisé", "Directeur marketing à temps partagé", "Fractional CMO", "CMO à temps partagé"],
          url: SITE_URL,
          description:
            "Fractional CMO, directeur marketing à temps partagé et externalisé pour PME et ETI, basée à Bordeaux, disponible partout en France. Formats de 2 à 12 jours par mois, tarif sur devis.",
          founder: FOUNDER,
          areaServed,
          knowsAbout: ["Directeur marketing à temps partagé", "Directeur marketing externalisé", "Fractional CMO"],
          knowsLanguage: ["fr", "en"],
          sameAs: ["https://linkedin.com/in/tiphanyrigaudias"],
        },
      ],
    }),
  component: Index,
});
